module.exports = __webpack_public_path__ + "img/Unidad21-6.305420f4.png";